import React from 'react';

import * as QueryParams from 'components/Explorer/models/query_params';
import useQueryParams from 'hooks/useQueryParams';
import useNavigateParams from 'hooks/useNavigateParams';

const SortBy = () => {
  const params = useQueryParams();
  const navigateParams = useNavigateParams();

  const onSortByChange = (event) => {
    if (event.target.value === 'followers_desc') {
      Analytics.trackEvent('sort-mention-author-followers');
    }
    navigateParams(QueryParams.withMentionSourceOrder(params, event.target.value));
  };

  return (
    <div className="Explorer-MentionSources-SortBy">
      <label className="label" htmlFor="sortby-select">
        {I18n.t('Explorer.MentionSources.SortBy.label')}
      </label>
      <select id="sortby-select" onChange={onSortByChange} value={params.mentionSourceOrder}>
        <option value="mentions_count_desc">
          {I18n.t('Explorer.MentionSources.SortBy.sort_options.mentions_count_desc')}
        </option>
        <option value="followers_desc">{I18n.t('Explorer.MentionSources.SortBy.sort_options.followers_desc')}</option>
      </select>
    </div>
  );
};

export default SortBy;
